module.exports = __webpack_public_path__ + "static/media/notavailable.27ccd06f.svg";